module.exports = __webpack_public_path__ + "img/c6.684d5fed.jpg";